import '../shared/i18n';
import './styles.scss';
import * as serviceWorker from '../serviceWorker';
import App from './App';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import moment from 'moment';
import store from '../store';

moment.locale('ru');

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

serviceWorker.register();
